import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useModalData } from '../../../components/modals/ModalsContext'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../components/helpers/Separator'

const ModalHeader = () => {
  const id = useModalData()?.id
  const isEditing = id > 0
  const context = isEditing && 'edit'

  const { t } = useTranslation('tags')
  const title = t('title_modal', { context })

  return (
    <>
      <Grid justify="space-between" align="center">
        <Col flex={1}>
          <Title size="h5" bold>
            {title}
          </Title>
        </Col>
      </Grid>

      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
